import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { useTheme } from 'providers/Theme.provider';

import useTip from 'hooks/useTip.hook';

import CN from './ExpandableText.module.scss';

const ExpandableText = props => {
  const { text, maxLines = 2 } = props;
  const { isDarkMode, isNeutralMode } = useTheme();

  const { val: expanded, tip: toggle } = useTip(false);
  const [needsTruncate, setNeedsTruncate] = useState(false);

  const textRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const calcStyles = window.getComputedStyle(textRef.current);
        const lineHeight = parseFloat(calcStyles.lineHeight);
        const maxHeight = maxLines * lineHeight; //   2 line × 20px line-height = 40px
        const actualHeight = textRef.current.scrollHeight;
        setNeedsTruncate(actualHeight > maxHeight);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [text, maxLines]);

  return (
    <div
      className={cn({
        [CN.component]: true,
        [CN.neutral]: isNeutralMode,
        [CN.dark]: isDarkMode,
      })}
    >
      <div
        ref={textRef}
        className={cn({
          [CN.expandableText]: true,

          [CN.expanded]: expanded,
          [CN.collapsed]: !expanded,
        })}
      >
        {text}
      </div>
      {needsTruncate && (
        <div className={CN.readMore} onClick={toggle}>
          {expanded ? 'Read less' : 'Read more'}
        </div>
      )}
    </div>
  );
};

export default ExpandableText;
